<!--If key ist undefined (when adding a new filter) show simple select-->
<div class="filter-criteria">
  @if (!formGroup.value.key) {
    <ino-select
      [formControl]="formGroup.controls.key"
      [outline]="true"
      [label]="'common:filterCriteria.filterKey' | i18next"
      class="filter-criteria__initial-select"
      data-cy="filter-criteria__initial-select">
      @for (option of translatedFilterKeyOptions; track option.label) {
        <ino-option [value]="option.value">
          {{ option.label }}
        </ino-option>
      }
    </ino-select>
  }

  <!--If key is already defined, show filter box-->
  @if (formGroup?.value?.key) {
    <app-filter-box
      [title]="label"
      [loading]="false"
      [collapsed]="collapsed"
      (collapsedChange)="toggleCollapsed()"
      [useCustomHeader]="!collapsed">
      <div header class="filter-criteria__header">
        <ino-select [formControl]="formGroup.controls.key" class="small no-line" data-testid="filter-header-select">
          @for (option of translatedFilterKeyOptions; track option.label) {
            <ino-option [value]="option.value" data-testid="filter-header-option"> {{ option.label }} </ino-option>
          }
        </ino-select>
        <div class="divider-line"></div>
      </div>

      <section data-cy="filter-criteria__input-group" [formGroup]="formGroup">
        @if (settingsTemplate) {
          <div class="mb-3 flex flex-col px-3">
            <ng-container *ngTemplateOutlet="settingsTemplate; context: { $implicit: formGroup }" />
          </div>
        }
        @if (showOperators) {
          <div class="grid grid-cols-[1fr_5fr] gap-2 px-3">
            <ino-select formControlName="operator" class="small operator-select" data-cy="filter-criteria__operator">
              @for (option of allowedOperators; track option) {
                @let optionId = option + '_' + uuid;
                <ino-option [value]="option">
                  <div class="flex w-full">
                    <div class="grow">{{ 'common:filterOperators.' + option | i18next }}</div>
                    <div>
                      <ino-icon [id]="optionId" icon="info" />
                      <ino-tooltip [for]="optionId" placement="left" delay="300" colorScheme="light">
                        {{ 'common:operatorTooltips.' + option | i18next }}
                      </ino-tooltip>
                    </div>
                  </div>
                </ino-option>
              }
            </ino-select>

            <ng-container [ngTemplateOutlet]="valueTemplate" [ngTemplateOutletContext]="{ $implicit: formGroup }" />
          </div>
        } @else {
          <div class="px-3">
            <ng-container [ngTemplateOutlet]="valueTemplate" [ngTemplateOutletContext]="{ $implicit: formGroup }" />
          </div>
        }
      </section>
    </app-filter-box>
  }
</div>
